import { stripHtml } from '~/lib/sanitization';

export const detectMultiSelect = (
  arr: Array<{ correct?: boolean | null; id: string }>
): string[] => {
  return arr
    .filter(
      (item: { correct?: boolean | null; id: string }) => item.correct === true
    )
    .map((item: { correct?: boolean | null; id: string }) => item.id);
};

const cleanQuestionPart = (value?: string | null): string =>
  stripHtml(value ?? '')
    .replace(/\s+/g, ' ')
    .trim();

/**
 * Fieldset legend for Yes/No / answer button groups (CAT-1436 / EL–E283).
 * Uses both Question title and body — do not require a "?".
 */
export const quizLegendText = (
  title?: string | null,
  body?: string | null
): string => {
  const heading = cleanQuestionPart(title);
  const copy = cleanQuestionPart(body);
  if (!heading) return copy;
  if (!copy) return heading;
  if (copy.includes(heading) || heading.includes(copy)) {
    return heading.length >= copy.length ? heading : copy;
  }
  return `${heading} ${copy}`;
};
